/** 与 sharp().webp() 默认质量一致 */
const WEBP_QUALITY = 0.8

export type CanvasPad = {
  left: number
  top: number
  size: number
}

/** 把裁切图贴回画布坐标，得到上传用的整幅图 */
export const padImageDataUrl = (
  dataUrl: string,
  pad: CanvasPad,
): Promise<string> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = pad.size
      canvas.height = pad.size
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        reject(new Error('canvas context unavailable'))
        return
      }
      ctx.drawImage(img, pad.left, pad.top)
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('canvas toBlob failed'))
          return
        }
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result))
        reader.onerror = reject
        reader.readAsDataURL(blob)
      }, 'image/png')
    }
    img.onerror = reject
    img.src = dataUrl
  })

const isWebpDataUrl = (dataUrl: string) =>
  /^data:image\/webp[;,]/i.test(dataUrl)

const encodeWebpDataUrl = (dataUrl: string): Promise<string> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      if (!ctx) {
        reject(new Error('canvas context unavailable'))
        return
      }
      ctx.drawImage(img, 0, 0)
      canvas.toBlob(
        (blob) => {
          if (!blob || blob.type !== 'image/webp') {
            reject(new Error('webp encode unsupported'))
            return
          }
          const reader = new FileReader()
          reader.onload = () => resolve(String(reader.result))
          reader.onerror = reject
          reader.readAsDataURL(blob)
        },
        'image/webp',
        WEBP_QUALITY,
      )
    }
    img.onerror = reject
    img.src = dataUrl
  })

/** 已是 webp 则原样返回；编码失败则退回原图，交给服务端再转 */
export const ensureWebpDataUrl = async (dataUrl: string): Promise<string> => {
  if (!dataUrl || isWebpDataUrl(dataUrl)) return dataUrl
  try {
    return await encodeWebpDataUrl(dataUrl)
  } catch {
    return dataUrl
  }
}

export const dataUrlToBlob = async (dataUrl: string): Promise<Blob> => {
  const res = await fetch(dataUrl)
  if (!res.ok) throw new Error('failed to read image blob')
  return res.blob()
}
